import Colours from '../../../style_helpers/colours'
import ConditionalStyle from '../../../style_helpers/conditional_style'

export function getInitialButtonState () {
  return {
    mouseOver: false,
    mouseDown: false,
    focused: false
  }
}

export function getIconLineWeight (props) {
  return isLargeButton(props) || isCircularButton(props) ? 2 : 1
}

export function canRenderIcon (props, location) {
  const { icon, iconLocation } = props
  return icon && iconLocation === location
}

export function isCircularButton (props) {
  return props.type === 'circular'
}

export function isLargeButton (props) {
  return props.size === 'large'
}

export function getButtonStyle (props, state, styles) {
  return {
    ...styles.base,
    ...styles.state,
    ...styles.buttonSizes[props.size].base,
    ...styles.buttonSizes[props.size][props.type],
    ...styles.buttonTypes[props.type].base,
    ...styles.buttonAlignment[props.align],
    ...ConditionalStyle(props.inline, styles.inline),
    ...ConditionalStyle(state.mouseOver, styles.buttonTypes[props.type].hover[props.hoverType]),
    ...ConditionalStyle(state.mouseDown, styles.buttonTypes[props.type].clicked[props.hoverType]),
    ...ConditionalStyle(state.focused, styles.focused),
    ...ConditionalStyle(props.disabled, styles.disabled.base),
    ...ConditionalStyle(props.disabled, styles.disabled[props.type])
  }
}

export function getIconStyle (props, state, styles) {
  return {
    ...styles.icon.base,
    ...styles.icon[props.iconLocation],
    ...styles.icon[props.type].base,
    ...styles.icon[props.type][props.size],
    ...ConditionalStyle(state.mouseOver, styles.icon[props.type].hover),
    ...ConditionalStyle(state.mouseDown, styles.icon[props.type].clicked),
    ...ConditionalStyle(props.disabled, styles.icon.disabled.base),
    ...ConditionalStyle(props.disabled, styles.icon.disabled[props.type])
  }
}

export function getContainerStyle (props, styles) {
  return {
    ...styles.container.base,
    ...ConditionalStyle(props.inline, styles.container.inline),
    ...ConditionalStyle(props.fullWidth, styles.container.fullWidth)
  }
}

export function getButtonComponentType (props) {
  return props.href ? 'a' : 'button'
}

export function getLoaderColour (props) {
  if (props.type === 'alpha') return Colours('white', '300')
  if (props.type === 'bravo') return Colours('grey', '500')
  return Colours(props.colour, '300')
}
